const SubscriptionTransactions = () => {
	return <div>SubscriptionTransactions</div>;
};

export default SubscriptionTransactions;
